// import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Persona',
  type: 'person',
  bodyClasses: 'resource-accordion',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
      },
    ],
    content: [
      {
        id: 'image-viewer',
        type: 'viewer',
        grid: 3,
      },
      {
        id: 'metadata',
        type: 'metadata',
        options: {
          readmore: {
            height: 200,
            labels: {
              more: 'readmore#more',
              less: 'readmore#less',
            },
          },
        },
      },
      {
        id: 'metadata-voyages',
        type: 'metadata-dynamic',
        options: {
          accordion: true,
          dynamic: true
        }
      },
      {
        id: 'collection-places',
        type: 'map',
        options: {
          libOptions: {
            layerUrl: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
            map_center: [37.00, 105.00],
          }
        },
      },
      {
        id: 'collection-people',
        type: 'collection',
        title: 'resource#collection_people',
        grid: 1,
      },
      {
        id: 'collection-primary-bibliography',
        type: 'collection',
        grid: 1,
        title: 'resource#primary-bibliography',
        options: {
          classes: 'mr-item-preview-bibliography',
          itemPreview: {
            limit: 9999,
            striptags: false,
          },
        },
      },
      {
        id: 'collection-secondary-bibliography',
        type: 'collection',
        grid: 1,
        title: 'resource#secondary-bibliography',
        options: {
          classes: 'mr-item-preview-bibliography',
          itemPreview: {
            limit: 9999,
            striptags: false,
          },
        },
      },
    ],
  },
};
